import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'
import Isvg from 'react-inlinesvg'

import ChevronIcon from 'assets/components/icon/chevron-icon.svg'
import styles from './collapsable_header.scss'

//CollapsableHeader should be a PureComponent because the bug unmounting elem on render multiple childs
class CollapsableHeader extends PureComponent {

	onButtonAction = e => {
		e.preventDefault()
		e.stopPropagation()
		this.props.onToggle()
	}

	render() {
		return (
			<div
				styleName={
					cn({
						Header: true,
						'Header--expanded': this.props.expanded,
						'Header--padding-right': this.props.hasRightPadding,
					})
				}
				onClick={this.props.onCollapsableClick}
			>
				<div
					styleName={
						cn({
							'Header-container': true,
						})
					}
				>
					{this.props.children}
					<button
						styleName={
							cn({
								'Header-toggle': true,
								'Header-toggle--expanded': this.props.expanded,
								'Header-toggle--offsetted': this.props.shouldOffsetCollapsableHeaderButton,
							})
						}
						onClick={this.onButtonAction}
						onTouchEnd={this.onButtonAction}
					>
						<Isvg styleName="Header-toggle-icon" src={ChevronIcon} cacheGetRequests={true} />
						{/* <ChevronIcon /> */}
					</button>
				</div>
			</div>
		)
	}
}

CollapsableHeader.propTypes = {
	children: PropTypes.any,
	expanded: PropTypes.bool.isRequired,
	onToggle: PropTypes.func.isRequired,
	shouldOffsetCollapsableHeaderButton: PropTypes.bool,
	hasRightPadding: PropTypes.bool,
}

CollapsableHeader.defaultProps = {
	expanded: true,
	onToggle: () => {},
	shouldOffsetCollapsableHeaderButton: false,
	hasRightPadding: false,
}

export default CSSModules(CollapsableHeader, styles, { allowMultiple: true })
